/* tslint:disable */
/* eslint-disable */
// @ts-ignore
import * as Types from '../../../../../global-graphql-types'

import { DocumentNode } from 'graphql'
import * as Apollo from '@apollo/client'
import * as ApolloReactHooks from 'utils/extendApolloHooks'
const defaultOptions = {} as const
export type CartApplyCouponVariables = Types.Exact<{
  cartUuid: Types.Scalars['String']
  couponCode: Types.Scalars['String']
}>

export type CartApplyCoupon = {
  __typename: 'Root'
  cartApplyCoupon: {
    __typename: 'CartApplyCouponPayload'
    cart: {
      __typename: 'Cart'
      id: number | null
      uuid: string | null
      coupon: { __typename: 'CartCoupon'; id: number; name: string } | null
    } | null
    errors: Array<{
      __typename: 'UserError'
      key: string | null
      message: string | null
    }> | null
  } | null
}

export const CartApplyCouponDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CartApplyCoupon' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'cartUuid' }
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'couponCode' }
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cartApplyCoupon' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'cartUuid' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'cartUuid' }
                }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'couponCode' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'couponCode' }
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cart' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'coupon' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' }
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'errors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode
export type CartApplyCouponMutationFn = Apollo.MutationFunction<
  CartApplyCoupon,
  CartApplyCouponVariables
>

/**
 * __useCartApplyCoupon__
 *
 * To run a mutation, you first call `useCartApplyCoupon` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCartApplyCoupon` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cartApplyCoupon, { data, loading, error }] = useCartApplyCoupon({
 *   variables: {
 *      cartUuid: // value for 'cartUuid'
 *      couponCode: // value for 'couponCode'
 *   },
 * });
 */
export function useCartApplyCoupon(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CartApplyCoupon,
    CartApplyCouponVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    CartApplyCoupon,
    CartApplyCouponVariables
  >(CartApplyCouponDocument, options)
}
export type CartApplyCouponHookResult = ReturnType<typeof useCartApplyCoupon>
export type CartApplyCouponMutationResult =
  Apollo.MutationResult<CartApplyCoupon>
export type CartApplyCouponMutationOptions = Apollo.BaseMutationOptions<
  CartApplyCoupon,
  CartApplyCouponVariables
>
